import { render } from "./BookingDuration.vue?vue&type=template&id=6d54720d"
import script from "./BookingDuration.vue?vue&type=script&lang=js"
export * from "./BookingDuration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__